export const AuthorGraphTypes = {
  'default': 'デフォルト',
  'circular': '円形'
}
export type AuthorGraphType = keyof typeof AuthorGraphTypes
export const isAuthorGraphType = (type: string) => Object.keys(AuthorGraphTypes).some(t => type === t)

export const SymbolSizeRuleTypes = {
  'link': '共著者数',
  'score': '論文スコア',
  'none': '固定'
}
export type SymbolSizeRuleType = keyof typeof SymbolSizeRuleTypes
export const isSymbolSizeRuleType = (type: string) => Object.keys(SymbolSizeRuleTypes).some(t => type === t)

export const AuthorGraphCategories = {
  'sotukou': '卒業校',
  'isikai': '医師会',
  'nenrei': '年齢',
  'seibetu': '性別',
  'sinryoka': '診療科',
  'kaikin': '開勤区分',
  'kanriBunrui': '勤務先分類',
  'tierRank': 'ユーザーランク'
}
export type AuthorGraphCategory = keyof typeof AuthorGraphCategories
export const isAuthorGraphCategory = (category: string) => Object.keys(AuthorGraphCategories).some(c => category === c)
